<template>
  <div class="title">
    <h2>
      <slot></slot>
    </h2>
    <span class="line" :style="`background: ${color}`"></span>
  </div>
</template>

<script>
export default {
  name: 'my-title',
  props: {
    color: {
      required: false,
      type: String,
      default: '#186dff'
    }
  }
}
</script>

<style lang="stylus" scoped>
.title
  padding 60px 0 30px
  text-align center

  h2
    font-size 30px
    color fontBlack
    font-weight normal

  .line
    display inline-block
    width 80px
    height 4px
    border-radius 2px
</style>


// WEBPACK FOOTER //
// src/components/basic/Title.vue